import {request} from "./request";

export function LoginUnlock(username) {
  return request({
    url: 'public/LoginUnlock',
    params: {
      username
    }
  })
}

export function LoginUnbind(id) {
  return request({
    url: 'public/LoginUnbind',
    params: {
      id
    }
  })
}
